import Style, { StyleFunction, StyleLike } from 'ol/style/Style';
import Text from 'ol/style/Text';
import Fill from 'ol/style/Fill';
import { FeatureLike } from 'ol/Feature';
import CircleStyle from 'ol/style/Circle';
import { Stroke } from 'ol/style';
import { Color } from 'ol/color';
import { ColorLike } from 'ol/colorlike';

export interface BadgeOptions {
  displacement: [number, number];
  backgroundColor: Color | ColorLike;
  color: Color | ColorLike;
}

export function addBadgeStyle(
  style: StyleLike,
  options: BadgeOptions,
): StyleFunction {
  return (feature: FeatureLike, resolution: number) => {
    const { displacement, backgroundColor, color } = options;
    const size = feature.get('features')?.length || 0;
    const radius = size > 99 ? 20 : size > 9 ? 15 : 13;
    const fontSize = 14;
    const resolvedStyle =
      typeof style === 'function' ? style(feature, resolution) : style;
    const mainStyle: Style | Style[] = resolvedStyle || [];

    const invisibleSignature = new Text({});

    if (mainStyle instanceof Style) {
      mainStyle.setText(invisibleSignature);
    } else {
      mainStyle.forEach((v) => {
        v.setText(invisibleSignature);
      });
    }

    if (size < 2) return mainStyle;

    const badge = new Style({
      image: new CircleStyle({
        radius: radius,
        fill: new Fill({ color: backgroundColor }),
        stroke: new Stroke({ color, width: 2 }),
        displacement,
      }),
      text: new Text({
        text: size.toString(),
        font: `bold ${fontSize}px sans-serif`,
        fill: new Fill({ color }),
        offsetX: displacement[0],
        offsetY: -displacement[1],
        textBaseline: 'middle',
        textAlign: 'center',
        overflow: true,
      }),
    });

    if (mainStyle instanceof Style) return [mainStyle, badge];

    return [...mainStyle, badge];
  };
}
